import React, { memo, useCallback } from 'react';

import { useSelector } from 'react-redux';

import {
  selectAggregatedProductCoreFields,
  selectAggregatedVariantContext,
} from '../../../../store/selectors/aggregatedProductDetailsSelectors';
import { navigateToVariantParent } from '../../helpers/navigateToVariantParent';
import VariantDetailsHeader from '../../VariantDetailsHeader';
import VariantContextBlock from '../../VariantContextBlock';
import { resolveAggregatedStatusValue } from '../helpers/resolveAggregatedStatusValue';

const AggregatedVariantHeaders = () => {
  const variantContext = useSelector(selectAggregatedVariantContext);
  const productCoreFields = useSelector(selectAggregatedProductCoreFields);
  const parentStatus = productCoreFields?.status
    ? resolveAggregatedStatusValue(productCoreFields.status)
    : variantContext?.parentStatus;

  const onNavigateToParent = useCallback(() => {
    if (!variantContext?.navigateProductId) return;
    navigateToVariantParent({ productId: variantContext.navigateProductId });
  }, [variantContext?.navigateProductId]);

  if (!variantContext) return null;

  return (
    <>
      <VariantDetailsHeader
        productTitle={variantContext.productTitle}
        variantDisplayName={variantContext.variantDisplayName}
        availableOptions={variantContext.availableOptions}
        variantOptions={variantContext.variantOptions}
      />
      <VariantContextBlock
        parentTitle={variantContext.productTitle}
        parentSku={variantContext.parentSku}
        parentStatus={parentStatus}
        availableOptions={variantContext.availableOptions}
        variantOptions={variantContext.variantOptions}
        canNavigateToParent={Boolean(variantContext.navigateProductId)}
        onNavigateToParent={onNavigateToParent}
      />
      <br />
    </>
  );
};

export default memo(AggregatedVariantHeaders);
